import React from "react";
import { Box, Button, Input, Select, SelectOption } from "@showitinc/showit-wc";

import AppConstants from "../../constants/AppConstants";
import { getWpCustomPostTypeFilter } from "../../utils/PropertyUtils";
import { initFormatter } from "../../utils/PropertyFormatters";

import styles from "./WPCustomPostTypeFilter.module.css";

const { UPDATE_ACTION_DELETE, UPDATE_ACTION_SET, WP_CAT, WP_TAG, WP_CPT_FILTER_TAXONOMY } =
  AppConstants;

const WPCustomPostTypeFilter = ({ filter, index, filterId, activeFilters, onPropUpdate }) => {
  const type = filter.get("type", WP_CAT);
  const { onChange } = initFormatter(onPropUpdate);
  const isDisabled = (category) =>
    activeFilters.get(index) !== category && activeFilters.includes(category);

  return (
    <div className={styles.filterContainer}>
      <Box d="flex" justify="end">
        <Button
          variant="icon"
          iconSuffix="close"
          onClick={onChange(filterId, undefined, true, false, undefined, UPDATE_ACTION_DELETE)}
        />
      </Box>
      <Select
        label="Filter By:"
        value={type}
        reserveContext
        shift="left"
        data-testid={filterId}
        onSISelect={(e) => {
          // Special case for "filter by" option value needs to be an immutable map returned by
          // getWpCustomPostTypeFilter function as opposed to a standard string value.
          onChange(
            filterId,
            type,
            true,
            false,
            undefined,
            UPDATE_ACTION_SET
          )(getWpCustomPostTypeFilter(e.detail.value));
        }}
      >
        <SelectOption value={WP_CAT} disabled={isDisabled(WP_CAT)}>
          Category
        </SelectOption>
        <SelectOption value={WP_TAG} disabled={isDisabled(WP_TAG)}>
          Tag
        </SelectOption>
        <SelectOption value={WP_CPT_FILTER_TAXONOMY}>Custom Taxonomy</SelectOption>
      </Select>

      {type === WP_CPT_FILTER_TAXONOMY && (
        <Input
          label="Taxonomy Slug"
          value={filter.get("taxSlug", "")}
          placeholder="podcast_topics"
          onSIChange={onChange(`${filterId}.taxSlug`, filter.get("taxSlug"))}
        />
      )}
      {type !== WP_TAG && (
        <Select
          label="Include/Exclude:"
          value={String(filter.get("include", 1))}
          reserveContext
          shift="left"
          onSISelect={onChange(`${filterId}.include`, filter.get("include"))}
        >
          <SelectOption value="1">Include</SelectOption>
          <SelectOption value="0">Exclude</SelectOption>
        </Select>
      )}
      <Input
        value={filter.get("val", "")}
        label={`Term Slug${type === WP_TAG ? "" : "(s)"}`}
        placeholder="cats, pet_health"
        propName={`${filterId}.val`}
        onSIChange={onChange(`${filterId}.val`, filter.get("val"))}
      />
    </div>
  );
};

export default WPCustomPostTypeFilter;
